import React from 'react';

import Button from '../buttons/Button';

function PoiStaticMap({ image, alt, openMap }) {
    const imageUrl = image?.files?.original?.url ? image.files.original.url : '/images/poi-card-fallback-image.jpg';

    const handleMapOpen = () => {
        openMap();
    };
    return (
        <div className="h-64 max-w-sm relative cursor-pointer">
            <a href="#map" onClick={handleMapOpen}>
                <img src={imageUrl} alt={alt} className="w-full h-full object-cover rounded-2xl" />
            </a>

            <div className="absolute bottom-3 w-full text-center">
                <Button onClick={handleMapOpen} color="white">
                    Odpri zemljevid
                </Button>
            </div>
        </div>
    );
}

PoiStaticMap.propTypes = {};

export default PoiStaticMap;
